import React, { useState } from 'react';
import useFilters from '../../../Base/Hooks/useFilters';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import FormControl from '../../../../Components/Form/FormControl';
import DoctorMultiSelectWithCheckList from '../../../Doctor/Components/DoctorMultiSelectWithCheckList/DoctorMultiSelectWithCheckList';
import WorkplaceSelect from '../../../Workplace/Components/WorkplaceSelect/WokrplaceSelect';

export interface WorkplaceCalendarWithFilterDefaultValues {
	doctorIds?: { value: string }[];
	workplaceId?: string;
}

export interface WorkplaceCalendarWithFilterValues {
	doctorIds?: string[];
	workplaceId?: string;
}

interface Props {
	onFilter: (values: WorkplaceCalendarWithFilterValues) => void;
	defaultValues?: WorkplaceCalendarWithFilterDefaultValues;
}

const WorkplaceCalendarFilter: React.FC<Props> = ({
	onFilter,
	defaultValues,
}) => {
	const [filterValues, setFilterValues] =
		useState<WorkplaceCalendarWithFilterValues>();
	const { handleMultiSelectValue, handleSelect } = useFilters();

	const onFilterData = (values: any) => {
		const workplaceId = handleSelect(values?.workplaceId);
		const workplaceHasChanged = filterValues?.workplaceId
			? workplaceId !== filterValues.workplaceId
			: false;
		if (workplaceHasChanged) {
			formMethods.setValue('doctorIds', []);
		}
		const filter: WorkplaceCalendarWithFilterValues = {
			doctorIds: workplaceHasChanged
				? undefined
				: handleMultiSelectValue(values?.doctorIds),
			workplaceId: handleSelect(values?.workplaceId),
		};
		setFilterValues(filter);
		onFilter(filter);
	};

	const formMethods = useForm({
		defaultValues,
	});

	const handleOnChange = () => {
		formMethods.handleSubmit(values => onFilterData(values))();
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<FormControl
				name='workplaceId'
				label='base.selectWorkplace'
				inLine
				hideRequired
				onChange={handleOnChange}>
				<WorkplaceSelect portal />
			</FormControl>
			<FormControl
				name='doctorIds'
				label='base.pickWorker'
				inLine
				hideRequired
				onChange={handleOnChange}>
				<DoctorMultiSelectWithCheckList
					placeholder='base.shared.pick'
					workplaceId={filterValues?.workplaceId}
					portal
				/>
			</FormControl>
		</FormWrapper>
	);
};

export default WorkplaceCalendarFilter;
